import React, { FC, ChangeEvent } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';

type GroupsPageActionsProps = {
    onNewGroupClick: () => void;
    onFilterChange: (filters: { freetext: string }) => void;
};
const GroupsPageActions: FC<GroupsPageActionsProps> = ({ onNewGroupClick, onFilterChange }: GroupsPageActionsProps) => {
    const { t: translate } = useTranslation(['lab-settings']);

    const handleFreetextChange = (freetext: string) => {
        onFilterChange({
            freetext: freetext,
        });
    };

    return (
        <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
            <TextField
                id="search-group"
                margin="dense"
                name="search"
                label={translate('lab-settings:SEARCH_GROUP')}
                onChange={(event: ChangeEvent<HTMLInputElement>) => handleFreetextChange(event.target.value)}
                sx={{ minWidth: '400px' }}
            />

            <Button sx={{ whiteSpace: 'nowrap' }} variant="contained" onClick={onNewGroupClick} startIcon={<AddIcon />}>
                {translate('lab-settings:NEW_GROUP')}
            </Button>
        </Box>
    );
};

export default GroupsPageActions;
